import { render } from "./App.vue?vue&type=template&id=2bdc5279"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2bdc5279&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.8_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__